exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdi-trash-can-outline:before{color:#f03737!important}", ""]);

// exports
